// export const svgIconHostLvbetcom: string = 'https://lvbet.com';

export const svgIconHostLvbetcom: string = 'https://image-assets-server-dot-cms-headless-gae.ew.r.appspot.com';
